import axios from 'axios'
import { set } from 'lodash'

export default {
    namespaced: true,
    state: {
        company: [],
        allCompanies: [],
        allCategories: [],
        pagination: null,
        loading: false,
    },
    mutations: {
        setStateObject(state: any, { name, value }) {
            set(state, name, value)
        },
    },
    actions: {
        getAllCompanies({ rootState, commit }, payload = { limit: 50, offset: 0, category_id: 0 }){
            const apiSession = rootState.user.apiSession
            const category_id = payload.category_id ? `&category_id=${payload.category_id}` : ''

            if(apiSession) {
                return axios({
                    method: 'get',
                    url: `${process.env.API_PRO}monitor/company?demo=true${category_id}`,
                    headers: { Authorization: `Bearer ${apiSession}` },
                }).then(e => {
                    if(e.data.data){
                        commit("setStateObject", { name: 'allCompanies', value: e.data.data })
                        commit("setStateObject", { name: 'allCategories', value: e.data.categories })
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
            return
        },
        getCompanies({ rootState, commit }, payload = { limit: 50, offset: 0, category_id: 0 }){
            const apiSession = rootState.user.apiSession
            const { limit, offset } = payload
            const category_id = payload.category_id ? `&category_id=${payload.category_id}` : ''
            commit("setStateObject", { name: 'loading', value: true })

            if(apiSession) {
                return axios({
                    method: 'get',
                    url: `${process.env.API_PRO}monitor/company?demo=true&limit=${limit}&offset=${offset}${category_id}`,
                    headers: {
                        Authorization: `Bearer ${apiSession}`
                    },
                }).then(e => {
                    if(e.data.data){
                        commit("setStateObject", { name: 'company', value: e.data.data })
                    }
                    if(e.data.pagination) {
                        commit("setStateObject", { name: 'pagination', value: e.data.pagination })
                    }
                    commit("setStateObject", { name: 'loading', value: false })
                }).catch(err => {
                    console.log(err)
                    commit("setStateObject", { name: 'loading', value: false })
                })
            }
            return
        },
        addCompany({ rootState, dispatch }, payload){
            const apiSession = rootState.user.apiSession

            return axios({
                method: 'post',
                url: `${process.env.API_PRO}monitor/company/insert?demo=true&limit=100&offset=0&category_id=1&ogrns[]=${payload}`,
                headers: {
                    Authorization: `Bearer ${apiSession}`
                },
            }).then(e => {
                if(e.data.status && e.data.status.code == 201) {
                    dispatch('getCompanies')
                    dispatch('getAllCompanies')
                } else if(e.data.status && e.data.status.message == "Возможно, закончился лимит по подписке") {
                    dispatch('showErrorPopUp', 'Закончился лимит по подписке',  { root: true })
                }
            }).catch(err => {
                console.log(err)
            })
        },
        removeCompany({ rootState, dispatch }, payload){
            const apiSession = rootState.user.apiSession
            
            return axios({
                method: 'post',
                url: `${process.env.API_PRO}monitor/company/delete?demo=true&limit=100&offset=0&category_id=1&ogrns[]=${payload}`,
                headers: {
                    Authorization: `Bearer ${apiSession}`
                },
            }).then(e => {
                if(e.data.status && e.data.status.code == 201) {
                    dispatch('getCompanies')
                    dispatch('getAllCompanies')
                }
            }).catch(err => {
                console.log(err)
            })
        },
        getCompanyChanges({ rootState, dispatch }, { company_id, offset, limit }){
            const apiSession = rootState.user.apiSession

            return axios({
                method: 'get',
                url: `${process.env.API_PRO}monitor/company/${company_id}?demo=true&limit=${limit}&offset=${offset}`,
                headers: {
                    Authorization: `Bearer ${apiSession}`
                },
            }).then(e => {
                if(e.data.data) {
                    dispatch('getCompanies')
                    dispatch('getAllCompanies')
                    return e.data
                }
            }).catch(err => {
                console.log(err)
            })
        },
        removeCompanies({ rootState, dispatch }, payload){
            const apiSession = rootState.user.apiSession

            return axios({
                method: 'post',
                url: `${process.env.API_PRO}monitor/company/delete?demo=true&limit=100&offset=0`,
                data: {
                    ogrns: payload
                },
                headers: {
                    Authorization: `Bearer ${apiSession}`
                },
            }).then(e => {
                if(e.data.status && e.data.status.code == 201) {
                    dispatch('getCompanies')
                    dispatch('getAllCompanies')
                    dispatch('showErrorPopUp', 'Компании удалены',  { root: true })
                }
            }).catch(err => {
                console.log(err)
            })
        },
        addCompanies({ rootState, dispatch }, payload){
            const apiSession = rootState.user.apiSession

            if(apiSession){
                return axios({
                    method: 'post',
                    url: `${process.env.API_PRO}monitor/company/insert?demo=true&limit=100&offset=0&category_id=1`,
                    data: { ogrns: payload },
                    headers: {
                        Authorization: `Bearer ${apiSession}`
                    },
                }).then(e => {
                    if(e.data.status && e.data.status.code == 201) {
                        dispatch('getCompanies')
                        dispatch('getAllCompanies')
                        dispatch('showErrorPopUp', 'Компании добавлены',  { root: true })
                        return e
                    } else if(e.data.error){
                        dispatch('showErrorPopUp', 'Ошибка, компании не добавлены',  { root: true })
                    } else if(e.data.status && e.data.status.message == "Возможно, закончился лимит по подписке") {
                        dispatch('showErrorPopUp', 'Закончился лимит по подписке',  { root: true })
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        },
        downloadXLSX({ rootState }, payload){
            const apiSession = rootState.user.apiSession
            const ogrn = payload ? `/${payload}` : ''
            
            return axios({
                method: "get",
                url: `${window.api_pro}monitor/company${ogrn}?demo=true&result_type=xlsx`,
                headers: { "Authorization": `Bearer ${apiSession}` },
            }).then(res => {
                if(res && res.data && res.data.data && res.data.data.file && res.data.data.file.link && res.data.data.file.link.url) {
                    window.location.replace(res.data.data.file.link.url)
                }
            })
        },
        setCategory({ rootState, dispatch }, { companies, category_id }){
            const apiSession = rootState.user.apiSession

            if(apiSession){
                return axios({
                    method: 'post',
                    url: `${process.env.API_PRO}monitor/company/set_category?demo=true&limit=100&offset=0&category_id=${category_id}`,
                    data: { ogrns: companies },
                    headers: {
                        Authorization: `Bearer ${apiSession}`
                    },
                }).then(e => {
                    if(e.data.status && e.data.status.code == 201) {
                        dispatch('getCompanies')
                        dispatch('getAllCompanies')
                        dispatch('showErrorPopUp', 'Категория присвоена',  { root: true })
                        return e
                    } else if(e.data.error){
                        dispatch('showErrorPopUp', 'Ошибка, категория не присвоена',  { root: true })
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        },
        watchCompanies({ rootState, dispatch }, payload){
            const apiSession = rootState.user.apiSession

            if(apiSession){
                return axios({
                    method: 'post',
                    url: `${process.env.API_PRO}monitor/company/watch?demo=true&limit=100&offset=0&category_id=1`,
                    data: { ogrns: payload },
                    headers: {
                        Authorization: `Bearer ${apiSession}`
                    },
                }).then(e => {
                    if(e.data.status && e.data.status.code == 201) {
                        dispatch('getCompanies')
                        dispatch('getAllCompanies')
                        dispatch('showErrorPopUp', 'Компании отмечены как прочитанные',  { root: true })
                        return e
                    } else if(e.data.error){
                        dispatch('showErrorPopUp', 'Ошибка, компании не добавлены',  { root: true })
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        },
        getGroups(){},
    },
    getters: {
        countUnseen: ({ company }) => {
            if(company.length){
                return company.map(e => parseInt(e.count_unseen)).reduce((a, b) => a + b, 0)
            }
        },
        countTotal: ({ company }) => {
            if(company.length){
                return company.map(e => parseInt(e.count_total)).reduce((a, b) => a + b, 0)
            }
        },
        allCountUnseen: ({ allCompanies }) => {
            if(allCompanies.length) {
                return allCompanies.map(e => parseInt(e.count_unseen)).reduce((a,b) => a + b, 0)
            }
        },
        allCountTotal: ({ allCompanies }) => {
            if(allCompanies.length){
                return allCompanies.map(e => parseInt(e.count_total)).reduce((a, b) => a + b, 0)
            }
        },
        allCompaniesOgrns: ({ allCompanies }) => {
            if(allCompanies.length) {
                return allCompanies.map(e => e.company_id)
            }
        },
        getCategoryNameById: () => ({
            // "1": 'Без категории',
            "2": 'Поставщик',
            "7": 'Недобросовестный поставщик',
            "4": 'Клиент',
            "3": 'Конкурент',
            "5": 'Должник',
            "8": 'Аффилированная структура',
            "6": 'VIP'
        }),
        getCategoriesListItemByOgrn: ({ allCategories }) => ogrn => allCategories.filter(e => parseInt(ogrn) == parseInt(e.company_id))[0]
    }
}
